import { useQuery } from '@tanstack/react-query'
import { MINUTE_IN_MS } from '@/modules/shared/constants/time'
import { getDrivers } from './getDrivers'
import { QUERY_KEY_CONFIG_COUNTRIES } from '../../constants'
import { DriversResponse, PaginatedDriversResponse } from './types'

type Props = {
  companyId: string
  page?: number
  pageSize?: number
  groupId?: number
  isActive?: boolean
  search?: string
  enabled?: boolean
}

/**
 * Fetches drivers list with optional pagination and filtering.
 */
export function useQueryDrivers(props: Props) {
  const { companyId, page, pageSize, groupId, isActive, search, enabled = true } = props
  
  return useQuery<DriversResponse | PaginatedDriversResponse>({
    // Discriminate from countries (which shares QUERY_KEY_CONFIG_COUNTRIES) and
    // from any other paginated list using the same prefix — see the matching
    // discriminator added in useQueryVehiclesList.
    queryKey: [QUERY_KEY_CONFIG_COUNTRIES, 'drivers', companyId, page, pageSize, groupId, isActive, search],
    queryFn: async () => {
      const { data } = await getDrivers(props)
      return data
    },
    enabled,
    staleTime: MINUTE_IN_MS * 60, // cache for 60 minutes
  })
}
